import BatchBankCard from "./BatchBankCard";
import * as DateFormatter from "../../../utils/DateFormatter";

export default class CardBatchResponse {
  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.batchSize = jsonResponse["batch-size"];
    this.creatingUserId = jsonResponse["creating-user-id"];
    this.dateCreated = jsonResponse["date-created"];
    this.dateCreatedFormatted = DateFormatter.prettifyDate(jsonResponse["date-created"]);
    this.assigned = jsonResponse["assigned"];
    this.numberOfCardsAssignedToAgents = jsonResponse["number-of-cards-assigned-to-agents"];
    this.numberOfCardsAssignedToCustomers = jsonResponse["number-of-cards-assigned-to-customers"];

    let bankCards = [];
    jsonResponse["batch-bank-cards"].forEach(jsonResponseBankCard => {
      bankCards.push(new BatchBankCard(jsonResponseBankCard));
      }
    );
    this.bankCards = bankCards;
  }
}
